import { Heading } from '@chakra-ui/core'
import React from 'react'
import { useParams } from 'react-router-dom'
import { BackButton } from '../../../components'
import {
  useGetBaoverifierTaskDefinitionQuery,
  Maybe,
  TaskDefinitionEntity
} from '../../../generated/graphql'
import { PageWrap } from '../../../layouts'
import DataFields from '../components/DataFields'

const ReportTask = () => {
  const params = useParams<{ taskId: string }>()
  const taskId = params?.taskId
  const { data } = useGetBaoverifierTaskDefinitionQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: taskId
    }
  })

  const task = data?.getBaoverifierTaskDefinition as Maybe<TaskDefinitionEntity>
  return (
    <PageWrap title="Report Task">
      <BackButton title="Back to Tasks List" />
      <Heading my={8} fontSize="2xl" fontWeight="extrabold">
        Reporting on {task?.attributes?.task_type?.data?.attributes?.title || 'Unknown Task'}
      </Heading>
      <DataFields task={task} />
    </PageWrap>
  )
}

export default ReportTask
